// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.4144 22.0002L2.00015 0.585938L0.585938 2.00015L2.58579 4H0V20H17V18.4142L22.0002 23.4144L23.4144 22.0002Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 19.7232L23.9001 19.6661L8.23404 4H17V8.43382L24 4.23382V19.7232Z"}}]};

const VideoCameraOffFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-camera-off-filled',
    ref,
    icon: element,
  },
));

VideoCameraOffFilledIcon.displayName = 'VideoCameraOffFilledIcon';

export default VideoCameraOffFilledIcon;
